function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
import styled from "styled-components";
import { space, color } from "styled-system";
var Svg = styled("svg")({
  flex: "none"
}, space, color);
var SvgHush = React.forwardRef(function (props, ref) {
  return React.createElement(Svg, _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    height: props.size,
    width: props.size,
    ref: ref
  }), React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.255 13.993c0-.345.002-.69 0-1.034-.001-.096.026-.17.116-.208.082-.036.168-.01.24.073.215.25.428.503.642.755.075.087.15.175.223.265a.132.132 0 01.029.075c.001.364.002.728 0 1.09a.636.636 0 01-.578.642.632.632 0 01-.666-.544c-.006-.042-.006-.084-.006-.127v-.987zm.002-6.758l-.002-.044V5.142c.001-.315.217-.58.51-.632a.623.623 0 01.737.616c.007.698.003 1.397.004 2.095l-.004.036c-.145-.249-.346-.373-.62-.373-.272 0-.474.12-.624.351zm-.002 9.46c.153.232.357.351.631.35.273 0 .472-.125.62-.356v1.735c0 .17.005.343-.01.51a.621.621 0 01-.653.565.628.628 0 01-.586-.624c-.004-.67-.002-1.34-.002-2.01v-.17zm1.251-6.62v1.246c0 .119-.037.183-.127.22a.231.231 0 01-.27-.071l-.543-.636c-.094-.11-.188-.218-.28-.33a.13.13 0 01-.03-.075c-.002-.536-.002-1.072 0-1.607a.63.63 0 01.575-.632c.296-.033.59.188.659.498a.749.749 0 01.015.159l.001 1.229zm1.299-2.532V5.878c.001-.302.173-.548.44-.632.405-.128.81.178.812.619.002.416 0 .831 0 1.246v2.096c0 .31-.186.56-.47.638a.627.627 0 01-.778-.562 1.515 1.515 0 01-.004-.115V7.543zM10.02 15.57v1.924a.634.634 0 01-.52.635c-.36.069-.718-.224-.729-.598-.003-.107 0-.214 0-.322v-3.564c0-.3.191-.552.47-.624a.626.626 0 01.779.609c.002.646 0 1.293 0 1.94zm0-7.084v2.624a.634.634 0 01-.492.63.629.629 0 01-.757-.608c-.004-.38 0-.758-.002-1.137v-4.13c0-.309.202-.567.49-.632a.626.626 0 01.76.616c.003.674 0 1.347 0 2.022l.002.615zm3.784 6.139v-2.85c0-.284.121-.495.375-.614.406-.188.862.113.877.573v5.736c0 .313-.18.562-.462.643a.626.626 0 01-.786-.555 1.548 1.548 0 01-.004-.12v-2.814.001zm3.82-2.9v4.455a.637.637 0 01-.503.64c-.37.08-.737-.215-.747-.6V7.28c0-.288.145-.519.389-.62.413-.173.86.137.86.598v4.467h.001zm-10-.006v4.461a.634.634 0 01-.489.638c-.375.09-.75-.206-.761-.6V7.267c0-.307.184-.556.465-.634a.626.626 0 01.785.602c.003.491 0 .983 0 1.475v3.009z",
    fill: "white"
  }));
});
SvgHush.displayName = "SvgHush";
SvgHush.defaultProps = {
  size: 24,
  color: "#292929"
};
export default SvgHush;